import Axios from "axios";
import alertEventBus from '@/eventBus/AlertEventBus';


class AxiosProcessor {

    static async put(url,data){
        return await this.call('put',url, true, data);
    }

    static async post(url,data){
        return await this.call('post',url, true, data);
    }

    static async get(url){
        return await this.call('get',url, true);
    }

    static async delete(url){
        return await this.call('delete',url, true);
    }

    static async list(url, data){
        return await this.call('get',url+'?'+this.serialize(data), false);
    }

    static async call(method, url, loading, data = {})
    {
        try
        {
            loading ? alertEventBus.setLoading() : null;
            let response = await Axios[method](url, data);
            loading ? alertEventBus.clearLoading() : null;
            return response.data.body;
        }
        catch (e)
        {
            loading ? alertEventBus.clearLoading() : null;
            throw e;
        }
    }

    static serialize (data)
    {
        let str = [];
        for (let param in data)
            if (data.hasOwnProperty(param) && data[param] != undefined) {
                let value = typeof data[param] === 'object' ? encodeURI(JSON.stringify(data[param])) : encodeURIComponent(data[param]);
                str.push(encodeURIComponent(param) + "=" + value);
            }
        return str.join("&");
    }
}

export {
    AxiosProcessor
};